import { getApiBase } from "../utils/apiBase";
import { useMutation } from "@tanstack/react-query";
import Cookies from "js-cookie";


export interface ExportReportDocxParams {
  projectId: string;
  reportId: string;
}

export interface ExportReportDocxResult {
  blob: Blob;
  filename: string;
}

const parseFilename = (contentDisposition: string | null): string => {
  if (!contentDisposition) return "report.docx";
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  if (match && match[1]) return match[1];
  return "report.docx";
};

export const exportReportDocx = async (
  params: ExportReportDocxParams,
): Promise<ExportReportDocxResult> => {
  const { projectId, reportId } = params;
  if (!projectId || !reportId) {
    throw new Error("Missing project or report identifier for DOCX export");
  }

  const csrfToken = Cookies.get("csrftoken") || "";
  const response = await fetch(
    `${getApiBase()}/api/projects/${projectId}/reports/${reportId}/export.docx`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "X-CSRFToken": csrfToken,
      },
    },
  );

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Failed to export report to DOCX");
  }

  const filename = parseFilename(response.headers.get("Content-Disposition"));
  const blob = await response.blob();
  return { blob, filename };
};

export const useExportReportDocx = () => {
  return useMutation({
    mutationFn: exportReportDocx,
  });
};
